/**
 * Generate a table of content
 */
export default function error404() {
    let $visual404 = $('.error-page .visual-animated');
    
    if (!$visual404.length) return;

    $visual404.addClass('open');
}